var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-container",class:{ 'margin-bottom': !_vm.data.hasNotBottomMargin }},_vm._l((_vm.data.options),function(item,index){return _c('div',{key:index,staticClass:"option",class:{
      active: item.isActive && _vm.data.hasSelect,
      bold: item.isBold,
      line: item.hasLine,
    },on:{"click":function($event){return _vm.toggleOption(item)}}},[_c('i',{class:item.icon}),_vm._v(" "+_vm._s(item.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }